import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";
import { logout } from "@/lib/api";
import { LogOut } from "lucide-react";
import { PlainlyMark } from "@/components/PlainlyMark";

export function SiteHeader({ minimal = false }) {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  // Branded Plainly Google sign-in (uses our own Google OAuth client so the
  // Google consent screen displays "Plainly", not "emergent.com").
  const signIn = () => {
    const apiUrl = process.env.REACT_APP_BACKEND_URL;
    window.location.href = `${apiUrl}/api/auth/google/start?next=/dashboard`;
  };

  const handleLogout = async () => {
    await logout();
    setUser(null);
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 glass-header">
      <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-2" data-testid="brand-home-link">
          <PlainlyMark className="w-8 h-8" />
          <span className="font-display text-xl">Plainly</span>
          <span className="hidden md:inline text-xs text-muted-foreground ml-1">Analytics, in plain English.</span>
        </Link>

        {!minimal && (
          <nav className="flex items-center gap-2">
            {user ? (
              <>
                <Link to="/dashboard" className="px-3 py-1.5 text-sm rounded-full hover:bg-secondary" data-testid="nav-dashboard">Dashboard</Link>
                <Link to="/analyze" className="px-3 py-1.5 text-sm rounded-full hover:bg-secondary" data-testid="nav-analyze">New Analysis</Link>
                <Link to="/billing" className="px-3 py-1.5 text-sm rounded-full hover:bg-secondary" data-testid="nav-billing">Billing</Link>
                {user.plan === "agency" && (
                  <Link to="/branding" className="px-3 py-1.5 text-sm rounded-full hover:bg-secondary" data-testid="nav-branding">Branding</Link>
                )}
                <div className="hidden md:flex items-center gap-2 ml-2">
                  {user.picture && (
                    <img src={user.picture} alt="" className="w-7 h-7 rounded-full" />
                  )}
                  <span className="text-sm text-muted-foreground">{user.name}</span>
                </div>
                <Button variant="ghost" size="sm" onClick={handleLogout} data-testid="logout-btn">
                  <LogOut className="w-4 h-4" />
                </Button>
              </>
            ) : (
              <Button
                onClick={signIn}
                data-testid="header-signin-btn"
                className="rounded-full bg-[#1E392A] hover:bg-[#152b20] text-[#F7F5F0]"
              >
                Sign in with Google
              </Button>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}

export default SiteHeader;
